import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Card,
  Chip,
  Divider,
  Grid,
  IconButton,
  Modal,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from "@mui/material";
import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { Postrequestcall } from "../../../request/Postrequest";
import {
  FETCH_CLIENT_TIMESHEETS_V2,
  FETCH_CLIENT_TIMESHEETJOBS_ACTIVITIES_EMPLOYEE,
  FETCH_CLIENT_TIMESHEET_JOBS_V2
} from "../../../constant/Apipath";
import { useSelector } from "react-redux";
import moment from "moment";
import { BIGrey } from "../../../assets/helpers";
import Loader from "../../../common/Loader";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CrewTemplateForm from "../crewTemplateForm/CrewTemplateForm";
import PictureViewer from "../../../common/PictureViewer";
import { ClientEnglishFallback } from "../../constant/ClientEnglishFallback";

let CLIENT_COLOR = "#000000";

export default function ClientViewCrewTimesheetForeman({ isOpen, onClose, id }) {
  const { loginData, selectedClientData, multiLanguageData } = useSelector((state) => state?.main);

  CLIENT_COLOR = selectedClientData?.AccentColor;
  const TOKEN = loginData?.accessToken;
  const USER_ID = loginData?.userInformation?.UserId;

  const {
    TEXT_ACTIVITIES,
    TEXT_HOURS,
    TEXT_QTY,
    TEXT_TIMESHEET_TOTAL,
    TEXT_EMPLOYEE,
    TEXT_NOTES,
    TEXT_ACTIVITY_TOTAL,
    TEXT_SUBMITTED_ON,
    TEXT_IN,
    TEXT_OUT
  } = ClientEnglishFallback?.AddTimesheetModal(multiLanguageData?.AddTimesheetModal || {});

  const { TEXT_SIGNATURE, TEXT_CLOSE } = ClientEnglishFallback?.Signature(
    multiLanguageData?.Signature || {}
  );

  const [data, setData] = useState([]);
  const [newTemplate, setNewtemplate] = useState(false);
  const [loader, setLoader] = useState(true);

  const [pictureViewerOpen, setPictureViewerOpen] = useState(false);
  const [imageIndex, setImageIndex] = useState(0);

  const [isSignature, setIssignature] = useState(false);
  const [signData, setSigndata] = useState(null);

  // Initial UseEffect --->
  useEffect(() => {
    if (isOpen) {
      fetchClientTimesheetData();
    }
    return () => { };
  }, [isOpen]);

  const fetchClientTimesheetData = async () => {
    try {
      setLoader(true);
      const timesheetObject = {
        PageNr: 1,
        FullSearch: "",
        UserId: USER_ID,
        IncludeRecordNr: true,
        FetchAllowedRecordsOnly: true,
        SearchList: [
          {
            ClientTimesheetId: id
          }
        ]
      };
      const getResponse = await Postrequestcall(
        FETCH_CLIENT_TIMESHEET_JOBS_V2,
        timesheetObject,
        TOKEN
      );
      if (getResponse.status === 200) {
        setData(getResponse?.data?.data?.[0] ?? {});
      }
    } catch (err) {
      console.log("fetchClientTimesheetData-> Error When Fetching Client Timesheet Jobs: ", err);
    } finally {
      setLoader(false);
    }
  };

  const getTextColorBasedOnStatus = (statusId) => {
    if (statusId === 1) {
      return "";
    } else if (statusId === 2) {
      return "success";
    } else if (statusId === 3) {
      return "error";
    } else {
      return "";
    }
  };

  const ImgUrl = (file) => {
    try {
      let url = URL?.createObjectURL(file);
      return url;
    } catch (error) {
      return file;
    }
  };

  const pictureListArray =
    data?.pictureList?.map((item) => {
      return {
        src: item?.fileUrl || ImgUrl(item?.file)
      };
    }) || [];

  const showSignature = async (item) => {
    try {
      const getObj = {
        PageNr: 1,
        NrOfRecPerPage: 20,
        FullSearch: "",
        UserId: USER_ID,
        IncludeRecordNr: true,
        FetchAllowedRecordsOnly: true,
        SearchList: [
          {
            ClientEmployeeId: item?.clientEmployeeId,
            ClientTimesheetId: item?.clientTimesheetId
          }
        ]
      };
      const getResponse = await Postrequestcall(
        FETCH_CLIENT_TIMESHEETJOBS_ACTIVITIES_EMPLOYEE,
        getObj,
        TOKEN
      );
      if (getResponse.status === 200) {
        setSigndata(getResponse?.data?.data[0]);
        setIssignature(true);
      }
    } catch (error) { }
  };

  return (
    <>
      <PictureViewer
        isOpen={pictureViewerOpen}
        viewerIndex={imageIndex}
        pictures={pictureListArray}
        onClose={() => setPictureViewerOpen(false)}
      />

      <Modal
        open={isOpen}
        onClose={onClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description">
        <Box
          sx={{
            padding: {
              xs: "10px",
              xl: "15px",
              lg: "15px",
              md: "15px",
              sm: "10px"
            },
            maxHeight: "650px",
            overflow: "auto"
          }}
          className="client-modal-responsive">
          {loader ? (
            <Stack sx={{ alignItems: "center", justifyContent: "center" }} width={"100%"}>
              <Loader />
            </Stack>
          ) : (
            <>
              <Stack sx={{ display: "flex",  margin: "5px 0px",  justifyContent: "space-between", alignItems: "center" }}  direction={"row"} >
                <IconButton size="small" onClick={onClose}>
                  <CloseIcon />
                </IconButton>
                <IconButton
                  size="small"
                  onClick={() => {
                    onClose();
                    setNewtemplate(true);
                  }}>
                  <ContentCopyIcon sx={{ color: CLIENT_COLOR }} />
                </IconButton>
              </Stack>
              <Stack sx={{ alignItems: "center", justifyContent: "space-between" }} direction={"row"}>
                <Chip color={getTextColorBasedOnStatus(data?.statusId)} label={data?.status} />
                <Typography style={{ color: BIGrey }}>
                  {TEXT_SUBMITTED_ON} {moment(data.dateSubmitted).format("MMMM D, YYYY")}
                </Typography>
              </Stack>
              <Stack style={{ marginTop: "10px" }}>
                <Typography style={{ color: BIGrey }}>
                  {moment(data.date).format("MMMM D, YYYY")}
                </Typography>
                <Typography>{`${data?.clientJobCode} - ${data?.clientJobName}`}</Typography>
              </Stack>
              <Grid size={12}>
                <Accordion
                  sx={{ background: "transparent", boxShadow: "none" }}
                  defaultExpanded={true}>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    sx={{
                      minHeight: "32px !important", // reduce overall height
                      "&.Mui-expanded": {
                        minHeight: "32px !important" // reduce height when expanded
                      },
                      "& .MuiAccordionSummary-content": {
                        margin: "10px 0 !important"
                      },
                      padding: "0px"
                    }}>
                    <Typography variant="h6" fontStyle={"normal"} sx={{ fontWeight: 500 }}>
                      {TEXT_ACTIVITIES}
                    </Typography>
                  </AccordionSummary>
                  {data?.timesheetActivitiesList?.map((act, index) => (
                    <AccordionDetails
                      sx={{
                        borderRadius: "10px",
                        padding: "0px",
                        marginBottom: "10px",
                        boxShadow: "none"
                      }}
                      className="pagelist-content">
                      <Stack style={{ padding: "12px" }}>
                        <Typography variant="h6">
                          {act?.clientJobActivityCode} - {act?.clientJobActivityName}
                        </Typography>
                      </Stack>
                      <TableContainer component={Paper} sx={{ boxShadow: "none" }}>
                        <Table
                          sx={{
                            minWidth: 350,
                            "& th": {
                              color: BIGrey,
                              padding: "0px 10px",
                              borderBottom: "0px"
                            },
                            "& td": {
                              padding: "5px 10px",
                              borderBottom: "0px"
                            }
                          }}
                          aria-label="simple table">
                          <TableHead>
                            <TableRow>
                              <TableCell variant="h6">{TEXT_EMPLOYEE}</TableCell>
                              {data?.type !== "Crew" && (
                                <>
                                  <TableCell variant="h6">{TEXT_IN}</TableCell>
                                  <TableCell variant="h6">{TEXT_OUT}</TableCell>
                                </>
                              )}
                              <TableCell variant="h6" sx={{ textAlign: "end" }}>
                                {TEXT_HOURS}
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {data?.timesheetHoursList?.map(
                              (hrs, index) =>
                                hrs?.clientJobActivityId === act?.clientActivityId && (
                                  <TableRow
                                    key={index}
                                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                                    <TableCell scope="row">
                                      <Typography>{hrs.clientEmployeeName}</Typography>
                                    </TableCell>
                                    {data?.type !== "Crew" && (
                                      <>
                                        <TableCell>{hrs?.clockInTime}</TableCell>
                                        <TableCell>{hrs?.clockOutTime}</TableCell>
                                      </>
                                    )}
                                    <TableCell style={{ textAlign: "end" }} scope="row">
                                      <Typography
                                        sx={{ color: hrs?.isHoursEdit ? CLIENT_COLOR : "#000" }}>
                                        {hrs?.hours}
                                      </Typography>
                                    </TableCell>
                                  </TableRow>
                                )
                            )}
                          </TableBody>
                        </Table>
                      </TableContainer>
                      <Divider style={{ height: 1, borderColor: "#cccccc", marginTop: 10 }} />
                      <Stack sx={{ marginTop: "10px",  padding: "0px 12px",  justifyContent: "space-between", alignItems: "center" }} direction={"row"}  >
                        <Typography variant="h6">{TEXT_ACTIVITY_TOTAL}</Typography>
                        <Typography variant="h6">
                          {act?.activityHours ? act?.activityHours : "00:00"}
                        </Typography>
                      </Stack>
                      <Stack
                        sx={{
                          padding: "12px",
                          background: "rgb(250, 250, 250)",
                          borderBottomRightRadius: "10px",
                          borderBottomLeftRadius: "10px"
                        }}>
                        {act?.isQuantityApplicable && (
                          <Stack sx={{ gap: 2 }} direction={"row"} >
                            <Typography>{TEXT_QTY}</Typography>
                            <Typography>
                              {act?.qty}
                              {"  "}
                              {act?.qtyUnit}
                            </Typography>
                          </Stack>
                        )}
                        <Stack
                          direction={"row"}
                           sx={{ gap: "10px", marginTop: act?.isQuantityApplicable ? "10px" : "0px" }}>
                          {act?.udFieldsList?.map(
                            (data, index) =>
                              data.value == "true" && (
                                <Chip
                                  key={index}
                                  size="small"
                                  sx={{ borderRadius: "5px" }}
                                  label={data?.label}
                                />
                              )
                          )}
                        </Stack>
                      </Stack>
                    </AccordionDetails>
                  ))}
                  <Stack sx={{ padding: "15px 0px",  justifyContent: "space-between", alignItems: "center" }} direction={"row"} >
                    <Typography variant="h6">{TEXT_TIMESHEET_TOTAL}</Typography>
                    <Typography variant="h6">{data?.totalHours}</Typography>
                  </Stack>
                </Accordion>
              </Grid>
              <Grid size={12}>
                <Accordion
                  sx={{ background: "transparent", boxShadow: "none" }}
                  defaultExpanded={true}>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    sx={{
                      minHeight: "32px !important", // reduce overall height
                      "&.Mui-expanded": {
                        minHeight: "32px !important" // reduce height when expanded
                      },
                      "& .MuiAccordionSummary-content": {
                        margin: "10px 0 !important"
                      },
                      padding: "0px"
                    }}>
                    <Typography variant="h6" fontStyle={"normal"} sx={{ fontWeight: 500 }}>
                      {TEXT_EMPLOYEE}
                    </Typography>
                  </AccordionSummary>
                  {data?.timesheetEmployeesList?.map((item) => (
                    <AccordionDetails
                      sx={{ borderRadius: "10px", padding: "0px", marginBottom: "10px" }}
                      className="pagelist-content">
                      <Stack
                        onClick={
                          item?.isSignature
                            ? (e) => {
                              e.preventDefault();
                              e.stopPropagation();
                            }
                            : (e) => {
                              e.preventDefault();
                              e.stopPropagation();
                            }
                        }
                        sx={{
                          cursor: item?.isSignature ? "pointer" : "initial",
                          padding: "12px",
                          gap: "10px"
                        }}>
                        <Stack sx={{ justifyContent: "space-between", alignItems: "center" }} direction={"row"} onClick={ item?.isSignature ? (e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                showSignature(item);
                              }
                              : (e) => {
                                e.preventDefault();
                                e.stopPropagation();
                              }
                          }>
                          <Stack direction={"row"} sx={{ gap: 1,  alignItems: "center"  }} >
                            <Typography variant="h6">{item?.clientEmployeeName}</Typography>
                            {item?.isSignature && (
                              <CheckCircleIcon fontSize="13" sx={{ color: CLIENT_COLOR }} />
                            )}
                          </Stack>
                          <Typography sx={{ color: BIGrey }}>
                            {item?.mileage} {item?.mileageUnit}
                          </Typography>
                        </Stack>
                        {item?.udFieldsList?.length > 0 && (
                          <Stack sx={{ gap: '10px' }} direction={"row"} >
                            {item?.udFieldsList?.map(
                              (data, index) =>
                                data.value == "true" && (
                                  <Chip
                                    key={index}
                                    size="small"
                                    sx={{ borderRadius: "5px" }}
                                    label={data?.label}
                                  />
                                )
                            )}
                          </Stack>
                        )}
                      </Stack>
                    </AccordionDetails>
                  ))}
                </Accordion>
              </Grid>
              <Grid size={12}>
                <Accordion
                  sx={{ background: "transparent", boxShadow: "none" }}
                  defaultExpanded={true}>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    sx={{
                      minHeight: "32px !important", // reduce overall height
                      "&.Mui-expanded": {
                        minHeight: "32px !important" // reduce height when expanded
                      },
                      "& .MuiAccordionSummary-content": {
                        margin: "10px 0 !important"
                      },
                      padding: "0px"
                    }}>
                    <Typography variant="h6" fontStyle={"normal"} sx={{ fontWeight: 500 }}>
                      {TEXT_NOTES}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails
                    sx={{ borderRadius: "10px", padding: "10px", marginBottom: "10px", backgroundColor: "#fafafa", }}>
                    <Typography>{data?.notes}</Typography>
                    {data?.pictureList?.length > 0 && (
                      <Stack
                        direction="row"
                         sx={{ gap: 1, width: "100%", overflowX: "auto" }}>
                        {data?.pictureList?.map((url, index) => (
                          <img
                            onClick={() => {
                              setImageIndex(index);
                              setPictureViewerOpen(true);
                            }}
                            key={index}
                            src={url?.thumbFileUrl}
                            alt={`Image ${index + 1}`}
                            style={{
                              maxWidth: "100px",
                              maxHeight: "100px",
                              minWidth: "100px",
                              minHeight: "100px",
                              objectFit: "cover",
                              cursor: "pointer",
                              borderRadius: "10px"
                            }}
                          />
                        ))}
                      </Stack>
                    )}
                    <Stack
                      direction={"row"}
                      gap={"10px"}>
                      {data?.udFieldsList?.map(
                        (data, index) =>
                          data.value == "true" && (
                            <Chip
                              key={index}
                              size="small"
                              sx={{ borderRadius: "5px" }}
                              label={data?.label}
                            />
                          )
                      )}
                    </Stack>
                  </AccordionDetails>
                </Accordion>
              </Grid>
            </>
          )}
        </Box>
      </Modal>

      <Modal
        open={isSignature}
        onClose={() => setIssignature(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description">
        <Box
          sx={{
            padding: {
              xs: "10px",
              xl: "15px",
              lg: "15px",
              md: "15px",
              sm: "10px"
            },
            backgroundColor: "rgb(235, 235, 235)",
            maxWidth: "450px"
          }}
          className="client-modal-responsive">
          <Stack sx={{ mb: 1 }}>
            <Typography variant="h6">{signData?.clientEmployeeName}</Typography>
          </Stack>
          <Stack>
            <Typography sx={{ mb: 1 }}>{TEXT_SIGNATURE}</Typography>
            <Card
              className="pagelist-content"
              sx={{ background: "transparent", display: "flex", justifyContent: "center" }}>
              <img
                loading="lazy"
                src={signData?.signature}
                alt={"NO data"}
                style={{
                  cursor: "pointer",
                  height: "100px",
                  borderRadius: "10px"
                }}
              />
            </Card>
          </Stack>
          <Stack sx={{ marginTop: "16px",  alignItems: "center" }} >
            <Button
              sx={{
                backgroundColor: "rgba(0, 0, 0, 0.08)",
                color: "#000",
                borderRadius: "10px",
                textTransform: "none",
                minWidth: "200px",
                fontSize: "15px"
              }}
              onClick={() => setIssignature(false)}>
              {TEXT_CLOSE}
            </Button>
          </Stack>
        </Box>
      </Modal>

      {newTemplate && (
        <CrewTemplateForm
          timeSheetData={data}
          from="CrewTimesheet"
          isOpen={newTemplate}
          onClose={() => {
            setNewtemplate(false);
            onClose();
          }}
          templateId={0}
        />
      )}
    </>
  );
}

